import { useState, useCallback } from 'react';
import { useStore } from 'src/stores/store';
import { Store } from 'src/stores/store.interface';
import { isTerminalTaskId } from '../customNode/customNodeEnums';

export function useTableTabState() {
	const [selectedTableTaskId, setSelectedTableTaskId] = useState<string | undefined>();
	const [isTableTaskPanelOpen, setIsTableTaskPanelOpen] = useState(false);

	const setActiveTaskDefinitionStore = useStore(
		(state: Store) => state.setActiveTaskDefinitionStore
	);
	const resetActiveTaskDefinitionStore = useStore(
		(state: Store) => state.resetActiveTaskDefinitionStore
	);

	const handleTableTaskSelect = useCallback((taskId: string) => {
		if (!taskId) {
			setSelectedTableTaskId(undefined);
			resetActiveTaskDefinitionStore();
			setIsTableTaskPanelOpen(false);

			return;
		}

		setSelectedTableTaskId(taskId);
		resetActiveTaskDefinitionStore();
		setIsTableTaskPanelOpen(false);
	}, [resetActiveTaskDefinitionStore]);

	const handleTableTaskEdit = useCallback((taskId: string) => {
		if (!taskId) {
			resetActiveTaskDefinitionStore();
			setIsTableTaskPanelOpen(false);

			return;
		}

		const taskDefinitions = useStore.getState().WFDefinition.taskDefinitions;
		const task = taskDefinitions.find(
			(t) => t.taskId === taskId && !isTerminalTaskId(t.taskId)
		);

		if (task) {
			setActiveTaskDefinitionStore({ ...task }, taskId, true);
			setSelectedTableTaskId(taskId);
			setIsTableTaskPanelOpen(true);
		}
	}, [setActiveTaskDefinitionStore, resetActiveTaskDefinitionStore]);

	const resetTableTabState = useCallback(() => {
		setSelectedTableTaskId(undefined);
		setIsTableTaskPanelOpen(false);
	}, []);

	return {
		selectedTableTaskId,
		isTableTaskPanelOpen,
		setIsTableTaskPanelOpen,
		handleTableTaskSelect,
		handleTableTaskEdit,
		resetTableTabState,
	};
}
